import { render, staticRenderFns } from "./Survey.vue?vue&type=template&id=0909b9b8&scoped=true"
import script from "./Survey.vue?vue&type=script&lang=ts"
export * from "./Survey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0909b9b8",
  null
  
)

export default component.exports